import { IHttpService } from "angular";
import { WorkflowRecord, WorkflowRecords } from "../models/WorkflowRecord";

export class WorkflowService {

  public static readonly id = "workflowService";

  /** @ngInject */
  public constructor(private readonly $http: IHttpService) {
  }

  public async list(accountId: number): Promise<WorkflowRecords> {
    const url = `/tradefloor/api/accounts/${accountId}/workflow`;
    const response = await this.$http.get<WorkflowRecords>(url);
    return response.data;
  }

  public async create(workflowRecord: object, accountId: number): Promise<void> {
    const url = `/tradefloor/api/accounts/${accountId}/workflow`;
    await this.$http.post(url, workflowRecord);
  }

  public async remove(workflowId: number, accountId: number): Promise<void> {
    const url = `/tradefloor/api/accounts/${accountId}/workflow/${workflowId}`;
    await this.$http.delete(url);
  }

  public async update(workflowId: number, accountId: number, workflowRecord: object): Promise<void> {
    const url = `/tradefloor/api/accounts/${accountId}/workflow/${workflowId}`;
    await this.$http.put(url, workflowRecord);
  }
}
